import React, { useEffect, useState } from "react";
import MaskGroup from "../../assets/MaskGroup.png";
import UserCreationLayout from "../../layouts/userCreation/userCreationLayout";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import RadioInput from "../../components/radioinput/radioinput";
import { Colors } from "../../utilities/colors";
import Button from "../../components/button/button";
import Input from "../../components/input/input";
import Dropdown from "../../components/dropdown/dropdown";
import styled from "styled-components";
import {
    schemaIos,
    selfIntoStaticContent,
    errorMessages,
    schema,
    rtcSchema,
    rtcDefaultVals
} from "../selfIntro/selfIntroFormConstant";
import { useTranslation } from "react-i18next";
import { deviceStore } from "../../utilities/devices";
import { updateValues } from "../selfIntro/reducer";
import { Col, Row } from "react-bootstrap";
import ErrorField from "../../components/errorField/errorField";
import { validateObf } from "../../services/apiCalls";
import Loader from "../../components/loader/loader";
import IntroSection from "../../components/introSection/introSection";
import { getUniqCode, RTCOnboardForm, onBoardFormGetData } from "../../services/apiCalls";
import UpdateSelfIntroPopUp from "../../components/dashboardPopup/updateSelfIntro";
import { removeKeys } from "../../utilities/commonFunctions";
import { toast } from "react-toastify";

const FormWrapper = styled.div`
      margin: 30px 0 0 0;
      max-width: 100%;
      @media (max-width: 1024px) {
        max-width: 100%;
      }
    `;
const LabelText = styled.label`
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
      color: ${Colors.labelText};
      margin-bottom: 10px;
      display: block;
    `;
const FormGroup = styled.div`
      margin-bottom: 25px;
    `;

const SubmitDiv = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  @media (max-width: 991.98px) {
    justify-content: center; 
  }
`;

const IdentificationWrapper = styled.div`
      display: -webkit-box;
      align-items: center;
      @media (max-width: 599px) {
      display: flex;
      flex-direction: row;
        justify-content: space-between;
        margin-bottom: 20px;
      }
    `;
const NationalityWrapper = styled.div`
      margin-bottom: 10px;
    `;


export default function RTCOnBoardScreen() {
    const formValues = useSelector((state) => state.selfIntroOne.value);
    const user_id = useSelector((state) => state.selfIntroOne.userId);
    
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [aboutFormErrors, setAboutFormErrors] = useState(false);
    const [uniqeCodeList, setUniqCodeList]= useState([]);
    const [selectecUniqCode, setSelectedUniqueCode]= useState([]);
    // const [showUpdateModal, setShowUpdateModal] = useState(false);
    const {
        control,
        handleSubmit,
        setValue,
        watch,
        resetField,
        setError,
        clearErrors,
        formState: { errors, values },
    } = useForm({
        defaultValues: { ...rtcDefaultVals },
        // resolver: deviceStore.platform === 'ios' ? yupResolver(schemaIos) : yupResolver(schema),
        resolver: yupResolver(rtcSchema)
        // context: { statesDisable, citiesDisable },
    });

    const formVal = watch();

    const inputChange = (e) => {
        const { name } = e.target;
        let value = e.target.value;

        if (value) {
            switch (name) {
                case "id_number":
                    if (formVal.id_type === 1) {
                        var oldValue = ("" + value).replace(/\D/g, "");

                        var isNum = true;
                        if (oldValue.length > 0) {
                            let lastDigit = oldValue.charAt(oldValue.length - 1);
                            isNum = !isNaN(lastDigit);
                        }

                        let newValue = `${oldValue.substring(0, 6)}${oldValue.length > 6 ? "-" : ""
                            }${oldValue.substring(6, 8)}${oldValue.length > 8 ? "-" : ""
                            }${oldValue.substring(8, 12)}`;

                        if (/^[a-zA-Z\d-]+$/.test(oldValue) && isNum) {
                            setValue("id_number", newValue);
                        }
                    } else {
                        formVal.id_number = formVal?.id_number?.toUpperCase();
                        setValue(
                            "id_number",
                            /^[a-zA-Z\d]+$/.test(value?.toUpperCase())
                                ? value?.toUpperCase()
                                : formVal.id_number
                        );
                    }
                    break;
                default:
                    break;
            }
        } else {
            setValue(name, value);
        }
    };

    const radioChange = (value, name) => {
        setValue(name, value);
        switch (name) {
            case "id_type":
                resetField("id_number");
                if(value === 0){
                    setValue("nationality", 0); 
                }else{
                   setValue("nationality", 1); 
                }
                
                break;

            default:
        }
    };


    const onInputChange = (name, e) => {
        const { value } = e.target;
        const re = /^[a-zA-Z\s]*$/;
        if (value === "" || re.test(value)) {
            setValue(name, value);
        }
    };

    const dropdownChange = (name, val) =>{
        switch (name){
            case "uniq_code":
                setSelectedUniqueCode(val);
                setValue("rtc_unique_code", val.value);
        }
    }

    const fetchUniqCodes = async () =>{
        const { data }= await getUniqCode();
        if(data && data?.status === 1){
            const uniqeCodeList = data?.data.map((item) => ({
                value: item.code,
                label: item.name
            }));
            setUniqCodeList(uniqeCodeList)
        }
    }

    const onValidate = async () => {
        if (formVal.id_number) {
            let code = formVal.id_type === 1 ? "1" : "0";
            let req = {
                data: formVal.id_number,
            };
            const { data, status } = await validateObf(req, code);
            if (data && data.status === 1) {
                clearErrors("id_number");
            } else {
                setError("id_number", { message: data && data.message });
            }
        }
    };

    const onSubmit = async (formData) => {
        
        if (Object.keys(errors).length === 0) {
            if (deviceStore.platform === 'ios') {
                // const updatedFormValues = {
                //   ...formValues,
                //   is_ios_registration: 1
                // };

                // // Update the value of "is_ios_registration" in formVal
                // const updatedFormVal = {
                //   ...formVal,
                //   is_ios_registration: 1
                // };
                // dispatch(updateValues({ ...updatedFormValues, ...updatedFormVal }));
                formData.is_ios_registeration = 1;
            }
            //change this when api is ready
            const { data } = await RTCOnboardForm(user_id, {
                name: formVal?.full_name,
                id_type: formVal?.id_type,
                id_number: formVal?.id_number,
                rtc_unique_code: formVal?.rtc_unique_code
            });
            if (data && data.status === 1) {
                dispatch(updateValues({ ...formValues, ...formVal }));
                setAboutFormErrors(false);
                window.allow_user_continue = true;
                navigate("/dashboard");
                // setShowUpdateModal(true);
                // localStorage.setItem("rtc_onboard_completed", "true");
            }

        }
    };

    const onErrorSubmit = () => {
        setAboutFormErrors(true);
    };

    useEffect(() =>{
        fetchUniqCodes();
    },[])

    const redirectToUpdateInstituition = async () => {
        const { data, status } = await onBoardFormGetData();
        if (data && data.status === 1) {
          const newObj = removeKeys(data.data);
          dispatch(updateValues({ ...newObj }));
          window.allow_user_continue = true;
          navigate("/self-intro");
          localStorage.setItem("is_rtc", data?.data?.is_rtc);
        } else {
          toast.error(data && data.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      };

      const onLaterUpdate = () =>{
        navigate("/dashboard")
      }
    return (
        <UserCreationLayout sidebarImg={MaskGroup}>
            <IntroSection
                name={t(selfIntoStaticContent.title)}
                description={t(selfIntoStaticContent.description)}
            />
            <FormWrapper>
                <FormGroup>
                    <LabelText>{t(deviceStore.platform === 'ios' ? selfIntoStaticContent.identificationIos : selfIntoStaticContent.identification)}</LabelText>
                    <Row>
                        <Col lg="12" md="12" style={{ padding: "0px" }}>
                            <IdentificationWrapper>
                                <Controller
                                    name="id_type"
                                    control={control}
                                    render={({ field }) =>
                                        selfIntoStaticContent.identifications.map(
                                            (identity, index) => (
                                                <RadioInput
                                                    key={identity.label + index}
                                                    {...field}
                                                    checked={identity.value == formVal.id_type}
                                                    onChange={() =>
                                                        radioChange(identity.value, "id_type")
                                                    }
                                                    label={t(identity.label)}
                                                    margin="20px"
                                                    name="id_type"
                                                />
                                            )
                                        )
                                    }
                                />
                            </IdentificationWrapper>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl="4" lg="6" md="6" style={{ padding: "0px" }}>
                            <Controller
                                name="id_number"
                                control={control}
                                render={({ field }) => (
                                    <Input
                                        placeholder={
                                            formVal.id_type === 1
                                                ? t(selfIntoStaticContent.identificationNum)
                                                : t("Passport Number")
                                        }
                                        {...field}
                                        maxLength={formVal.id_type === 1 ? 14 : 16}
                                        onChange={inputChange}
                                        onBlur={onValidate}
                                        showMaxLimitMessage ={false}
                                    />
                                )}
                            />
                            {errors.id_type && <ErrorField err={t(errorMessages.id_type)} />}
                            {errors.id_number && (
                                <ErrorField err={t(errors.id_number.message)} />
                            )}
                        </Col>
                    </Row>
                </FormGroup>

                <FormGroup style={{ paddingLeft: "0px" }}>
                    <LabelText>{t(selfIntoStaticContent.fullName)}</LabelText>
                    <Controller
                        name="full_name"
                        control={control}
                        render={({ field }) => (
                            <Input
                                type="text"
                                onChange={(e) => onInputChange("full_name", e)}
                                placeholder={t("Full Name")}
                                {...field}
                                value={formVal.full_name}
                                checked={1 === formVal.nationality}
                                label={selfIntoStaticContent.malaysian}
                                maxLength="100"
                                showMaxLimitMessage ={false}
                            />
                        )}
                    />
                    {errors.full_name && (
                        <ErrorField err={t(errors.full_name.message)} />
                    )}
                </FormGroup>

                <FormGroup style={{ paddingLeft: "0px" }}>
                    <LabelText>{t(selfIntoStaticContent.uniq_code)}</LabelText>
                    <Controller
                        name="rtc_unique_code"
                        control={control}
                        render={({ field }) => (
                            // <Input
                            //     type="text"
                            //     onChange={(e) => onInputChange("unique_code", e)}
                            //     placeholder={t("Please enter unique code")}
                            //     {...field}
                            //     value={formVal.unique_code}
                            //     // checked={1 === formVal.nationality}
                            //     // label={selfIntoStaticContent.malaysian}
                            //     maxLength="100"
                            // />

                            <Dropdown
                                search={true}
                                menuPortal
                                menuPlacement="auto"
                                showScrollbar
                                maxMenuHeight={180}
                                options={uniqeCodeList}
                                change={(val) => dropdownChange("uniq_code", val)}
                                val={selectecUniqCode?.value}
                                label={selectecUniqCode?.label}
                                placeholder={t("Select Unique Code")}
                                {...field}
                                refCallback={field?.ref}
                                ref={null}
                            />
                        )}
                    />
                    {errors.rtc_unique_code && (
                        <ErrorField err={t(errors.rtc_unique_code.message)} />
                    )}
                </FormGroup>
                <Row>
                    <Col lg="4">
                        <FormGroup>
                            {/* {formErrors && <ErrorField err={t(formErrors)} />} */}
                            {loading ? (
                                <Loader />
                            ) : (
                                    <SubmitDiv>
                                        <Button
                                            onClick={handleSubmit(onSubmit, onErrorSubmit)}
                                            name={t("Continue")}
                                            width="198px"
                                        />
                                    </SubmitDiv>
                            )}
                        </FormGroup>
                        {aboutFormErrors && (
                                  <ErrorField
                                    err={
                                      t("Please make sure all the mandatory fields have been inserted")
                                    }
                                  />
                                )}
                    </Col>
                </Row>


            </FormWrapper>

            {/* <UpdateSelfIntroPopUp
                setShowUpdateModal={setShowUpdateModal}
                show={showUpdateModal}
                onCancel={onLaterUpdate}
                redirectToUpdateInstituition={redirectToUpdateInstituition}
            /> */}

        </UserCreationLayout>
    )
}